export const getDateTime = () => {
    const currentDateTime = new Date();

    const options = {
        hour: '2-digit',
        minute: '2-digit',
    };

    const time = currentDateTime.toLocaleTimeString('en-US', options);
    const day = currentDateTime.getDate();
    const month = currentDateTime.toLocaleString('en-US', { month: 'long' });
    const year = currentDateTime.getFullYear();

    return `${time} , ${day}${getDaySuffix(day)} ${month} ${year}`;
}

const getDaySuffix = (day) => {
    if (day >= 11 && day <= 13) {
        return 'th';
    }
    switch (day % 10) {
        case 1:
            return 'st';
        case 2:
            return 'nd';
        case 3:
            return 'rd';
        default:
            return 'th';
    }
}